import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';
import axios from 'axios';

// Components
import Button from '../../components/Button/Button';
import Anime from '../../components/Anime/Anime';

// Containers
import ContentHeader from '../../containers/ContentHeader/ContentHeader';
import Hero from '../../containers/Hero/Hero';
import HeroLayer from '../../containers/Hero/HeroLayer';

const API_PATH = '/api/contact-form.php';

class PageContact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            subject: "Pre-sales Questions",
            message: "",
            mailSent: false,
            error: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({
           [event.target.name] : event.target.value
        });
    }

    handleSubmit(event) {

        axios({
            method: 'post',
            url: `${API_PATH}`,
            headers: { 'content-type': 'application/json' },
            data: this.state
        })
        .then(result => {
            this.setState({
                name: "",
                email: "",
                subject: "Pre-sales Questions",
                message: "",
                mailSent: result.data.sent
            })
        })
        .catch(error => this.setState({ error: error.message }));
            event.preventDefault();
        }


    render () {
         return (
            <div className="app-section mb-sm">
                    <MetaTags>
                        <title>Contact with Rascals Themes</title>
                        <meta 
                            name="description" 
                            content="If you have pre-sale questions, then this is a good place to ask them." 
                        />
                    </MetaTags>

                 <Hero height="auto" classes="hero-page">
                	<div className="container">
	            	 	<ContentHeader 
	                        title="Say hello!" 
	                        subTitle="Got question? Don't hesitate and fill in the form on the left!" 
	                        classes="" 
	                    />

	                </div>
		            <HeroLayer
	                	classes="lines-bg anim anim--fade anim--duration-4 anim--delay-3"
	                	styleOuter={{
	                		zIndex:1
	                	}}
	                	styleInner={{
	                		top: 0,
	                		bottom: 0,
	                		left:0,
	                		right:0,
	                		opacity:0.6,
                    		backgroundSize: "cover",
	                		backgroundImage: "url(https://rascalsthemes.com/images/dark-texture.jpg)",
	                	}}
	                />
            	</Hero>

                <div className="container">
                    <div className="row row-large-gutter">
                        <div className="col-md-6 col-12 mb mb-sm">
                            <form className="contact-form" onSubmit={this.handleSubmit}>
                                <div className="row row-small-gutter">
                                    <div className="col-md-6">
                                    	<Anime type="fade-up" delay="3" duration="3">
	                                        <input 
	                                            type="text" 
	                                            name="name" 
	                                            value={this.state.name} 
	                                            onChange={this.handleChange} 
	                                            placeholder="Full Name" 
	                                            className="contact-form__name" 
	                                            required 
	                                        />
                                        </Anime>
                                    </div>
                                    <div className="col-md-6">
                                    	<Anime type="fade-up" delay="3" duration="3">
	                                        <input 
	                                            type="text" 
	                                            name="email" 
	                                            value={this.state.email} 
	                                            onChange={this.handleChange} 
	                                            placeholder="Email Address" 
	                                            className="contact-form__email" 
	                                            required 
	                                        />
	                                    </Anime>
                                    </div>
                                    <div className="col-md-12">
                                    	<Anime type="fade-up" delay="4" duration="3">
	                                        <select
	                                            name="subject"
	                                            value={this.state.subject}
	                                            onChange={this.handleChange}
	                                            placeholder="Subject" 
	                                            className="contact-form__subject" 
	                                            required 

	                                        >
	                                            <option value="General Questions">General Questions</option>
	                                            <option value="Pre-sales Questions">Pre-sales Questions</option>
	                                            <option value="Theme Customization">Theme Customization</option>
	                                        </select>
	                                    </Anime>
                                    </div>
                                    <div className="col-md-12">
                                    	<Anime type="fade-up" delay="5" duration="3">
	                                        <textarea 
	                                            name="message" 
	                                            value={this.state.message} 
	                                            onChange={this.handleChange} 
	                                            placeholder="Message" 
	                                            className="contact-form__message" 
	                                            required 
	                                        />
                                        </Anime>
                                    </div>
                                    <div className="col-md-12">
                                    	<Anime type="fade-up" delay="6" duration="3">
                                        	<input type="submit" value="Send Email" />
                                        </Anime>
                                    </div>
                                </div>
                                <div>
                                    {this.state.mailSent &&
                                        <div className="msg--info">Thank you for contcting us.</div>
                                    }
                                </div>
                            </form>


                        </div>

                        <div className="col-md-6 col-12 mb mb-sm">
                            <Anime type="fade-up" delay="3" duration="3">
                            	<h2>Need help?</h2>
                            </Anime>
                            <Anime type="fade-up" delay="4" duration="3">
                            	<p className="support-desc">If you bought our theme and you have questions or issues then do not hesitate - register, log in, create a ticket with a complete description of your problem and our support team will investigate it and get back to you as soon as it's possible.</p>
                            </Anime>
                            <Anime type="fade-up" delay="5" duration="3">
                            <p>
                                <Button title="Open a Ticket" link="http://rascalslabs.ticksy.com" icon="" classes="shadow" /> 
                            </p>
                            </Anime>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default PageContact;


// WEBPACK FOOTER //
// ./src/pages/PageContact/PageContact.js